import { FaFacebook, FaInstagram, FaEnvelope} from "react-icons/fa";
import './scss/_footer.css';
import React from "react";
import footerlogo from "../foot-aura-white.png";


export default function Footer() {
    const links = [
        { href: "#behandlinger", label: "Behandlinger", id: "ft-behandlinger" },
        { href: "#priser",       label: "Priser" , id: "ft-priser"},
        { href: "#omoss",        label: "Om Meg" , id: "ft-omoss"},
        { href: "#kontakt",      label: "Kontakt" , id: "ft-kontakt"},
        { href: "#gavekort",      label: "Gavekort" , id: "ft-gavekort"},
    ];
    const lovdata =[
        { href: "https://lovdata.no/lov/1999-07-02-64" , label: "Helsepersonelloven" },
        { href: "https://lovdata.no/forskrift/2000-12-21-1385", label: "Pasientjournal" },
        { href: "https://lovdata.no/lov/2018-06-15-38" , label: "Personopplysningsloven" },
        { href: "https://lovdata.no/lov/2001-06-15-53",  label: "Pasientskadeloven" },
        { href: "https://lovdata.no/lov/1994-08-05-55",  label: "Smittevernloven" },
        { href: "https://lovdata.no/lov/1999-07-02-63",  label: "Pasientrettighetsloven" },
        { href: "https://lovdata.no/lov/1999-07-02-61",  label: "Spesialhelsetjenesteloven" },

    ]
    return (
        <footer id="footer">
            <div className="cs-container flex">
                <div className="footer-menu">
                    <div>
                        <img src={footerlogo} className="footer-logo"/>
                    </div>
                    <a href="https://www.facebook.com/profile.php?id=61586829748063" target="blank" className="cs-link footer-icon"><FaFacebook size={24} color="#5c6065" /></a>
                    <a href="https://instgram.com/footaura"  target="blank" className="cs-link footer-icon"><FaInstagram size={24} color="#5c6065" /></a>
                    <a href="mailto:post@footaura.no"  target="blank" className="cs-link footer-icon"><FaEnvelope size={24} color="#5c6065"/></a>
                    <p >
                        Org. Nummer: 936 623 670
                    </p>
                </div>
                <div className="footer-menu">
                    <span>Oppdage</span>
                    <ul>
                    {links.map(({ href, label }) => {
                         return (
                            <li key={href}>
                                <a
                                    className={`footer-link`}
                                    href={href}
                                >
                                    {label}
                                </a>
                            </li>
                        );
                    })}
                    </ul>
                </div>
                <div className="footer-menu">
                    <span>Lovverk vi følger</span>
                    <ul>{lovdata.map(({ href, label }) => {
                        return (
                            <li key={href}>
                                <a
                                    className={`footer-link`}
                                    href={href}
                                    target = {`blank`}
                                >
                                    {label}
                                </a>
                            </li>
                        );
                    })}</ul>
                </div>


            </div>
            <div className="cs-bottom">
                <span className="cs-copyright">Copyright © 2025-{new Date().getFullYear()} FootAura</span>
            </div>
        </footer>
    );
}